module.exports = __webpack_public_path__ + "img/bg-doodles-farm.d4c676bb.png";